import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'extensionDocument' })
export class ExtensionDocumentPipe implements PipeTransform {
  transform(path: string | null | undefined, match: string): boolean {
    const ext = path?.split('.').at(-1) ?? '';
    return ext === match;
  }
}
